import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { SortEvent } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-ng-table',
  templateUrl: './ng-table.component.html',
  styleUrls: ['./ng-table.component.css'],
})


export class NgTableComponent {
  gridStyle = {'font-size': "14px", color: 'black' };
  headerStyle = {...this.gridStyle, "background": "#bedde7"};

  private _data: any[] = [];
  totalItems: number = 0;
  showingItems: number = 0;
  date: Date | undefined; 
  @Input() columns: any[] = [];
  @Input() stripedRows: boolean = true;
  @Input() scrollable: boolean = false;
  @Input() scrollHeight: string = "0px";
  @Input() tableStyle: any = {};
  @Input() headerStyles: any = this.headerStyle;
  @Input() gridStyles: any = this.gridStyle;
  @Input() allowFilters: boolean = false;

  @Output() sortFunction = new EventEmitter<any>();
  
  @ViewChild('dt') table: Table | undefined; // Access the p-table instance


  @Input()
  set data(value: any[]) {
    this._data = value || [];
    this.totalItems = this._data.length;
  }

  get data(): any[] {
    return this._data;
  }


	onSort(event: SortEvent){
    this.sortFunction.emit(event);
	}

  filterCallback(event:any = null, field:string){
    let value = event?.value ?? null;

    if (this.table) {
      if(value){
        this.table.filter(value, field, 'equals');
      }else{
        this.table.filters[field] = {value: null, matchMode: 'equals'};
      }
      this.table._filter();
    }
  }

  onFilter(event: any){
    this.showingItems = event?.filteredValue.length ?? this.data.length;
  }

}
